import angular from 'angular';
import SearchStoreComponent from './search.component';

const searchStoreModule = angular.module('tinaba.common.storeselect.search', [])

.component('searchStore', SearchStoreComponent);

export default searchStoreModule;



/** WEBPACK FOOTER **
 ** ./client/app/common/components/storeSelect/search/search.js
 **/